import React from 'react';

import LazyLoad from './LazyLoad';

function Video({ url }) {
  return (
    <>
      {url && (
        <LazyLoad>
          <div className="video">
            <iframe
              className="video__iframe"
              src={url}
              title="Convelio Video"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </LazyLoad>
      )}
    </>
  );
}

export default Video;
